import { ADDBOOKING, DELETEBOOKING } from "./actionTypes";

const initialState = [];

// reducer
const bookingReducer = (state = initialState, action) => {
 switch (action.type) {
  case ADDBOOKING:
   return [
    ...state,
    {
     id: Math.random().toString(35).slice(9),
     from: action.payload.bookingData.from,
     to: action.payload.bookingData.to,
     date: action.payload.bookingData.date,
     guests: action.payload.bookingData.guests,
     ticketClass: action.payload.bookingData.ticketClass,
    },
   ];
  case DELETEBOOKING:
   return state.filter((booking) => booking.id !== action.payload.id);
  default:
   return state;
 }
};

export default bookingReducer;
